import React from "react";
import { useDispatch, useSelector } from "react-redux";
import sliderCloseIcon from "../../assets/images/slider-close-icon.svg";
import deletePopupIcon from "../../assets/images/delete-popup-icon.svg";
import { deleteContact } from "../../redux/action";
import { Box } from "@chakra-ui/react";

export default function DeleteContactModal({ selectedContact }) {
  const dispatch = useDispatch();
  const userSelectedFont = useSelector((state) => state.settings.fontsize);

  return (
    <div
      className="modal fade"
      id="delteContact"
      tabIndex="-1"
      aria-labelledby="delteContactLabel"
      aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <Box
              fontSize={
                userSelectedFont === "small"
                  ? "18px"
                  : userSelectedFont === "medium"
                  ? "20px"
                  : userSelectedFont === "large"
                  ? "24px"
                  : "24px"
              }
              className="modal-title"
              id="delteContactLabel">
              Delete Record
            </Box>
            <button
              type="button"
              className="slider-close-btn"
              data-bs-dismiss="modal">
              <img src={sliderCloseIcon} className="img-fluid" />
            </button>
          </div>
          <div className="modal-body">
            <div className="d-flex justify-content-center">
              <img src={deletePopupIcon} />
            </div>
            <div className="mt-4">
              <p className="text-center">
                Do you really want to remove this record?{" "}
              </p>
            </div>
          </div>
          <div className="d-flex justify-content-center mb-4">
            <button className="slider-cancel-btn me-2" data-bs-dismiss="modal">
              Cancel
            </button>
            <button
              className="slider-success-btn"
              data-bs-dismiss="modal"
              onClick={() => dispatch(deleteContact(selectedContact))}>
              Remove
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
